import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import { CommunityHiking } from 'images/latest'

const CommunityHikingIcon = ({ color = 'black' }) => (
  <ResponsiveSVG
    width='48px'
    height='33px'
    className='unstyled'
    fill={color}
    SVG={CommunityHiking}
  />
)

export default CommunityHikingIcon
